import React, { useState } from 'react';
import { friendList,screenType,scsreenType } from './myFunctions';
export default function FriendPaged({oym,list,dropBreadcrumb}) {
    console.log(list);
    console.log(window.innerHeight,window.innerWidth);
    let objectList=list.map(friend => oym.objectRef(friend));
    // console.log("FIL dropBreadcrumb function:",dropBreadcrumb);
    // console.log(objectList);
    objectList.sort(oym.compareFriend);
    const [pageNo,setPage] =  useState(0);
    console.log(pageNo);
    let buttonSize=3;
    let pageLength=20;
    let friendIndex=-1;
    let friendsOnPage=objectList.filter(friend=>{
        ++friendIndex;
        console.log(friendIndex,pageNo*pageLength,(pageNo*pageLength),(friendIndex % pageLength),(pageNo*pageLength)+(friendIndex % pageLength));
        return friendIndex>=(pageNo*pageLength)&&friendIndex<=((pageNo*pageLength)+(friendIndex % pageLength));
    })
    if (screenType()==="TwoLetterButton"){
        buttonSize=2;
    }
    if (screenType()==="OneLetterButton"){
        buttonSize=1;
    }
    function tocButton(pageNum,lastFriendOnPage,firstFriendOnPage) {
        console.log("FriendPaged tocButton:"+pageNum,lastFriendOnPage,firstFriendOnPage,oym);
        console.log("PageLength #3 "+pageLength);
        if (screenType()==="Small"){
            buttonSize=1;
            return(
                <><span style={{cursor: "default"}} onClick={(e)=>tocClick(pageNum,e)}>{firstFriendOnPage.sortKey.substr(0,buttonSize)}</span>&nbsp;</>
            )
        }
        if (screenType()==="TwoLetterButton"){
            let buttonTitle=firstFriendOnPage.sortKey.substr(0,1)+lastFriendOnPage.sortKey.substr(0,1);
            return (
                <><button onClick={(e)=>tocClick(pageNum,e)}>{buttonTitle}</button>&nbsp;</>
            )
        } else {
            let buttonTitle=firstFriendOnPage.sortKey.substr(0,1)+"-"+lastFriendOnPage.sortKey.substr(0,1);
            return (
                <><button onClick={(e)=>tocClick(pageNum,e)}>{buttonTitle}</button>&nbsp;</>
            )
        };
    }

    console.log(friendsOnPage);
    friendIndex=-1;
    let toc=[];
    let firstFriendOnThisPage=null;
    let lastFriendOnThisPageIndex=pageLength-1;  // index only on one page
    console.log("PageLength #1 "+pageLength);
    let pageNum=0;
    objectList.forEach(friend=>{
        ++friendIndex;  // overall index on entire list of friends.
        if (friendIndex % pageLength==0){ // Is this the first friend on this page?
            pageNum=friendIndex / pageLength;
            firstFriendOnThisPage=friend;
        } else if (friendIndex % pageLength==lastFriendOnThisPageIndex){  // is this the last friend on this page
            toc.push(
                tocButton(pageNum,friend,firstFriendOnThisPage)
            )
        }
    })
    console.log("PageLength #2 "+pageLength);
    console.log(toc);
    function tocClick(pageNum,e){
        setPage(pageNum);
    }
    function next(e){
        if ((pageNo+1)*pageLength<list.length){
            setPage(pageNo+1);;
        }
        
    }
    function previous(e){
        if(pageNo>0){
           setPage(pageNo-1);
        }
    }

    return (
        <div> 
            {friendList(friendsOnPage,oym,dropBreadcrumb)}
            <section id="menu">
                <button onClick={previous}>Previous</button>&nbsp;
                {toc}
                <button onClick={next}>Next</button>
            </section>
        </div>
    )
}
